import { getHelpUrl } from '@change-corgi/config/help';
import { useI18n } from '@change-corgi/core/react/i18n';

import { useLocale } from 'src/app/shared/hooks/l10n';

import { processLinkGroup } from './processLinkGroup';
import type { LinkGroup } from './types';

export function useHelpLegalLinks(): LinkGroup | null {
	const { translate } = useI18n();
	const locale = useLocale();

	return processLinkGroup({
		title: translate('corgi.components.footer.section.help_and_legal'),
		links: [
			{
				href: getHelpUrl(locale),
				title: translate('corgi.components.footer.links.help_center'),
			},
			{
				href: '/policies/community',
				title: translate('corgi.components.footer.links.community_guidelines'),
			},
			{
				href: '/policies/privacy',
				title: translate('corgi.components.footer.links.privacy_policy'),
			},
			{
				href: '/policies/terms-of-service',
				title: translate('corgi.components.footer.links.terms_of_service'),
			},
			{
				href: '/policies/cookies',
				title: translate('corgi.components.footer.links.cookie_policy'),
			},
			{
				href: '/u/manage_cookies',
				title: translate('corgi.components.footer.links.manage_cookies'),
			},
		],
	});
}
